import { render, staticRenderFns } from "./create-note-modal.vue?vue&type=template&id=0e3d1122&lang=pug"
import script from "./create-note-modal.vue?vue&type=script&lang=js"
export * from "./create-note-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports